export default __webpack_public_path__ + "static/media/FeverInTheOceans_08.6b82aa70.png";